<template>
  <el-row class="type-container"
          :gutter="10">
    <el-col :xs="24"
            :span="5"
            class="mb-15">
      <el-card shadow="none">
        <div slot="header">
          <span><i class="el-icon-discount mr-10"></i>字典分类</span>
          <el-tooltip class="item"
                      effect="dark"
                      content="添加字典类型"
                      placement="top"
                      style="float: right; padding: 3px 8px">
            <el-button v-has="'/dict_type/add'"
                       plain
                       type="primary"
                       @click="addType">+</el-button>
          </el-tooltip>
        </div>
        <div>
          <el-tree highlight-current
                   class="type-tree"
                   ref="typeTree"
                   node-key="code"
                   :expand-on-click-node="false"
                   :current-node-key="currentKey"
                   :data="tabList"
                   :props="defaultProps"
                   @node-click="handleNodeClick">
            <span class="custom-tree-node"
                  slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button v-has="'/dict_type/edit'"
                           type="text"
                           size="mini"
                           icon="el-icon-edit"
                           @click.stop="() => editType(node, data)"></el-button>
                <el-button v-has="'/dict_type/del'"
                           type="text"
                           size="mini"
                           icon="el-icon-delete"
                           @click.stop="() => removeType(node, data)"></el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24"
            :span="19">
      <el-card shadow="none">
        <div slot="header">
          <el-button v-has="'/dict/add'"
                     size="small"
                     type="primary"
                     @click="addItem">新增</el-button>
          <el-button v-has="'/dict/batch_del'"
                     size="small"
                     type="primary"
                     @click="multipleDelete">批量删除</el-button>
          <div style="float: right;">
            <el-input size="small"
                      clearable
                      v-model="searchName"
                      placeholder="字典名称">
              <el-button slot="append"
                         icon="el-icon-search"
                         @click="handleSearch"></el-button>
            </el-input>
          </div>
        </div>
        <el-table max-height="605"
                  :data="tableData"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="80"></el-table-column>
          <el-table-column v-for="(item, index) in tableTitle"
                           :key="index"
                           :label="item.name"
                           :prop="item.prop"
                           :min-width="item.width"
                           :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="操作"
                           width="200">
            <template slot-scope="scope">
              <el-button v-has="'/dict/edit'"
                         size="mini"
                         type="primary"
                         @click="editItem(scope.row)">编辑</el-button>
              <el-button v-has="'/dict/batch_del'"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination :total="pagination.total"
                    :current="pagination.currentPage"
                    :pageSize="pagination.perPage"
                    @handleSizeChange="handleSizeChange"
                    @handleCurrent="handleCurrentChange"></Pagination>
      </el-card>
    </el-col>
    <add-type v-if="showTypeModal"
              :isShow="showTypeModal"
              :data="typeData"
              @handleClose="closeTypeModal"></add-type>
    <add-item v-if="showItemModal"
              :isShow="showItemModal"
              :data="itemData"
              @handleClose="closeItemModal"></add-item>
  </el-row>
</template>
<script>
import fetch from '@/common/api'
import AddType from '@/views/system/type/AddType'
import AddItem from '@/views/system/type/AddItem'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { Pagination, AddType, AddItem },
  data() {
    return {
      currentKey: '',
      defaultProps: {
        label: 'name'
      },
      searchName: '',
      tabList: [],
      tableTitle: [
        {
          prop: 'name',
          name: '字典名称',
          width: '100'
        },
        {
          prop: 'code',
          name: 'code',
          width: '100'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加字典类型相关
      showTypeModal: false,
      typeData: {
        type: 'add'
      },
      // 添加类目相关
      showItemModal: false,
      itemData: {
        type: 'add'
      }
    }
  },
  created() {
    this.getTypeList().then(() => {
      this.getItemList()
    })
  },
  methods: {
    // 获取列表
    getTypeList() {
      return Promise.resolve(
        fetch.getTypeList({}).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.tabList = data.list
              this.currentKey = data.list[0].code
              this.$nextTick(function () {
                this.$refs.typeTree.setCurrentKey(data.list[0].code)
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    getItemList() {
      const { currentPage, perPage } = this.pagination
      return Promise.resolve(
        fetch
          .getItemList({
            currentPage: currentPage,
            perPage: perPage,
            type_code: this.currentKey,
            name: this.searchName
          })
          .then((data) => {
            data.procData(
              data.res,
              (data) => {
                this.pagination.total = Number(data.total)
                this.tableData = data.list
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
      )
    },
    // 搜索右侧列表
    handleSearch() {
      this.getItemList()
    },
    // 树形菜单单击
    handleNodeClick(data) {
      if (data.code !== this.currentKey) {
        this.currentKey = data.code
        this.getItemList()
      }
    },
    // 添加字典类型
    addType() {
      this.showTypeModal = true
      this.typeData = {
        type: 'add'
      }
    },
    // 编辑字典类型
    editType(node, data) {
      this.showTypeModal = true
      this.typeData = {
        type: 'edit',
        id: data.id
      }
    },
    // 关闭添加字典类型弹窗
    closeTypeModal(params) {
      if (params === 'refresh') {
        this.getTypeList()
      }
      this.showTypeModal = false
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 添加具体类目
    addItem() {
      this.showItemModal = true
      this.itemData = {
        pId: this.currentKey,
        type: 'add'
      }
    },
    // 编辑类目
    editItem(data) {
      this.showItemModal = true
      this.itemData = {
        pId: this.currentKey,
        type: 'edit',
        id: data.id
      }
    },
    // 关闭添加类目弹窗
    closeItemModal(params) {
      if (params === 'refresh') {
        this.getItemList()
      }
      this.showItemModal = false
    },
    // 删除字典类型
    removeType(node, data) {
      this.$confirm('是否确定删除该数据类型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delType({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getTypeList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    },
    // 搜索提交
    searchSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('已提交')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delItem(data.id)
        })
        .catch(() => {})
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delItem(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择字典名称后重试')
      }
    },
    delItem(ids) {
      fetch.batchDelItem({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getItemList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>
<style lang="less">
.type-tree.el-tree {
  .el-tree-node__content {
    height: 40px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>
